import { DateTime } from 'luxon'

export function isLockDateExpired(seconds: number) {
	const nowDate = DateTime.now()
	const endDate = DateTime.fromSeconds(seconds)

	return nowDate.diff(endDate).as('seconds') > 0
}
